<template>
  <el-card class="detail">
    <div class="line"></div>
    <div class="title-1">
      <img src="@/assets/chengjiao.png" />
      <span class="m-l-10">成交汇总详情</span>
    </div>
    <div class="title-2">
      <span>成交详情</span>
    </div>
    <div class="content">
      <el-form :model="data" label-width="155px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="成交总单号">
              {{ data.id }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="市场">
              {{ data.marketName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户号">
              {{ data.userAccount }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称">
              {{ data.userName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="报价方向">
              {{ data.billType | keyFilter('transation', 'billType') }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="成交总数量">
              {{ data.qty }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成交总额">
              {{ data.amount ? '￥' : '' }}{{ data.amount | thousandMark }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="合同状态">
              <el-tag :type="data.contractSign ? 'success' : 'waring'">{{ data.contractSign ? '已签署' : '未签署'}}</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同签署时间">
              {{ data.contractTime }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="成交总单状态">
              {{ data.orderStatus | keyFilter('transation', 'orderStatus') }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="title-2">
      <span>成交明细</span>
    </div>
    <div class="content p-b-50">
      <el-table :data="product" border stripe  class="m-t-20">
        <el-table-column label="成交单号" prop="id" align="center"/>
        <el-table-column label="品种" prop="product.varietyName" align="center"/>
        <el-table-column label="品牌" prop="product.brandName" align="center"/>
        <el-table-column label="规格" prop="product.specs" align="center"/>
        <el-table-column label="榨季" prop="product.government" align="center"/>
        <el-table-column label="工艺" prop="product.technique" align="center"/>
        <el-table-column label="产地" prop="product.origin" align="center"/>
        <el-table-column label="仓库" prop="product.whName" align="center"/>
        <el-table-column label="交货日期" prop="product.deliveryDate" align="center"/>
        <el-table-column label="成交数量" prop="qty" align="center"/>
        <el-table-column label="成交时间" prop="tradingDate" align="center"/>
      </el-table>
    </div>
    <div class="btn-box">
      <el-button plain @click="close">返回</el-button>
    </div>
  </el-card>
</template>

<script>
import API from '@/api'
export default {
  name: 'detail',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data: {},
      product: [],
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const param = {
        id: this.row.id
      }
      API.transationManage.totalDetail(param).then(res => {
        this.data = res.data
        this.product = res.data.tradingRecordList
      })
    },
    // 委托状态颜色
    getColor () {
      switch (this.data.tradingStatus) {
        case 'CANCEL': // 已过期
          return 'info'
        case 'BREAK': // 违约
          return 'info'
        case 'PART_OK': // 部分成交
          return 'warning'
        case 'ALL_OK': // 全部成交
          return 'success'
        case 'SUCCESS': // 交易成功
          return 'success'
        default:
          return ''
      }
    },
    close () {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
.title-1 {
  margin-bottom: 20px;
  height: 40px;
  line-height: 40px;
  span {
    font-size: 24px;
    font-weight: 600;
  }
  img {
    position: relative;
    top: -4px;
  }
}
.title-2 {
  padding: 20px 50px;
  top: 50px;
  border-bottom: 1px dashed #ebebeb;
  span {
    font-size: 16px;
    font-weight: 600;
  }
}
.detail ::v-deep {
  position: relative;
  .line {
    width: 100%;
    height: 1px;
    background-color: #ebebeb;
    top: 80px;
    left: 0;
    position: absolute;
  }
  .el-row {
    border-bottom: 1px dashed #ebebeb;
    margin: 0;
    padding: 10px 0px;
    height: 59px;
    line-height: 59px;
  }
  .el-col {
    padding: 0 50px;
  }
  .el-form-item {
    margin: 0;
  }
}
.p-b-50 {
  padding-bottom: 50px;
}
.btn-box {
  width: calc(100% - 200px);
  text-align: center;
  padding: 30px;
  position: fixed;
  bottom: 0;
  left: 200px;
  background-color: #ffffff;
  background-color: #ffffff;
  box-shadow: 0px -4px 20px 0px rgba(110, 110, 110, 0.1);
  button {
    width: 124px;
    height: 40px;
    background-color: #ffc600;
    border-radius: 4px;
  }
}
</style>
